module.exports = __webpack_public_path__ + "static/media/environmentalscan.8782a93c.pdf";